import React, { useEffect, useState } from "react";
import { useLocation, useParams, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Template } from "../../../commons/elements";
import StripeForm from "../components/stripe-form";
import { USER } from "../../../constants";
import { getBuyerIdentity as getBuyerIdentityAction } from "../../../state/buyer-identity/actions";
import { submitPlayerPurchaseStripe as submitPlayerPurchaseStripeAction } from "../../../state/purchase/actions";
import eventType from "../../../prop-types/eventType";
import Axios from "../../../utils/axios";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired,
  // Map state to props
  user: PropTypes.object.isRequired,
  buyerIdentity: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      buyerId: PropTypes.string
    })
  }).isRequired,
  purchase: PropTypes.shape({
    isSubmitting: PropTypes.bool,
    error: PropTypes.string
  }).isRequired,
  productSummary: PropTypes.object.isRequired,
  submitPlayerPurchaseStripe: PropTypes.func.isRequired
};

function PurchaseContainerStripe(props) {
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const [stripePromise, setStripePromise] = useState(null);

  const { types, productSummary, user, purchase, submitPlayerPurchaseStripe } =
    props;

  useEffect(() => {
    if (stripePromise == null) {
      setStripePromise(
        loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {
          stripeAccount: productSummary.stripeMerchantId
        })
      );
    }
  }, [stripePromise]);
  const metadata = {
    platform: "PrestoSports - Streaming",
    event_id: params.eventId,
    pass_name: productSummary.name,
    name_purchaser: `${user.firstName} ${user.lastName}`,
    email_purchaser: user.username,
    order_total: productSummary.cost,
    productId: productSummary.id
  };
  const options = {
    mode: "payment",
    amount: productSummary.cost,
    currency: productSummary.currency.toLowerCase()
  };
  return (
    <Template
      header="Billing Info"
      tabName={USER}
      types={types}
      fullHeight
      fullWidth
    >
      <Elements stripe={stripePromise} options={options}>
        <StripeForm
          productSummary={productSummary}
          eventId={params.eventId}
          user={user}
          history={history}
          location={location}
          shortName={params.shortName}
          metadata={metadata}
          purchase={purchase}
          submitPlayerPurchaseStripe={submitPlayerPurchaseStripe}
          loadingState={Axios.loadingState}
        />
      </Elements>
    </Template>
  );
}

PurchaseContainerStripe.propTypes = propTypes;

const mapStateToProps = (state) => ({
  user: state.user.user,
  buyerIdentity: state.buyerIdentity.buyerIdentity,
  purchase: state.purchase.purchase,
  productSummary: state.events.events.selectedProduct
});

const mapDispatchToProps = {
  getBuyerIdentity: getBuyerIdentityAction,
  submitPlayerPurchaseStripe: submitPlayerPurchaseStripeAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PurchaseContainerStripe);
